import { setElementAttribute, setStyleAttribute } from '../misc'

const CHALLENGE_FRAME_ID = 'challengeFrame'

export default function createIFrame(url: string, publicKey: string, sessionId: string): HTMLIFrameElement {
  const iframeElement = document.createElement('iframe')
  setElementAttribute(iframeElement, {
    src: url,
    name: CHALLENGE_FRAME_ID,
    id: CHALLENGE_FRAME_ID,
  })

  setStyleAttribute(iframeElement, {
    width: '500px',
    height: '200px',
    border: 'none',
  })

  iframeElement.addEventListener('load', () => {
    const frame = document.getElementById(CHALLENGE_FRAME_ID) as HTMLIFrameElement
    if (frame !== null) {
      // TODO: Update targetOrigin
      frame.contentWindow?.postMessage({ publicKey: publicKey, sessionId: sessionId }, '*')
    }
  })

  return iframeElement
}
